module.exports = __webpack_public_path__ + "assets/img/horizotalus-moguliu-isdestymas.55b2a9b4.webp";